import { useSelector } from "react-redux";
import {
  getUniversalUrl,
  universalUrlIsReady,
} from "../../api/features/nav/selectors";
import { getAppBaseUrl } from "../../../../../main/utils";

export default function useUniversalUrl() {
  const isReady = useSelector(universalUrlIsReady);
  const urlSuffix = useSelector(getUniversalUrl);
  const fullAppUrl = isReady ? `${getAppBaseUrl()}${urlSuffix}` : "";

  return {
    fullAppUrl,
    urlSuffix,
    isReady,
  };
}
